import { makeStyles } from '@mui/styles';

export const useStyles = makeStyles((theme) => ({
  podcastInfo: {
    padding: 16,
    borderRadius: 8,
    marginBottom: 5,
    width: '100%',
    '& $podcastInfoText': {
      color: 'var(--text-color)',
      fontSize: 16,
      fontWeight: 300,
      [theme.breakpoints.down('sm')]: {
        display: 'none',
      },
    },
    '& $podcastImage': {
      width: 60,
      borderRadius: 4,
      marginTop: 10,
      boxShadow: '0px 0px 10px 0px rgba(0, 0, 0, 0.4)',
      [theme.breakpoints.down('sm')]: {
        width: 80,
        height: 80,
      },
    },
    '& $podcastName': {
      color: 'var(--text-color)',
      fontSize: 24,
      fontWeight: 700,
      fontFamily: 'Montserrat',
      [theme.breakpoints.down('sm')]: {
        fontSize: 22,
      },
    },
    '& $podcastTitle': {
      display: 'flex',
      alignItems: 'center',
      gap: '5px',
      marginBottom: 6,
      [theme.breakpoints.down('sm')]: {
        flexWrap: 'wrap',
        marginBottom: 15,
      },
    },
    '& $podcastEpisodes': {
      fontSize: 16,
      fontWeight: 500,
      color: 'var(--text-color)',
      [theme.breakpoints.down('sm')]: {
        display: 'none',
      },
    },
    '& $podcastCategoriesWrapper': {
      display: 'flex',
      alignItems: 'center',
      gap: 0,
      marginLeft: 40,
      [theme.breakpoints.down('sm')]: {
        gap: 15,
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'baseline',
        marginLeft: 0,
      },
    },
    '& $podcastCategories': {
      fontSize: 16,
      fontWeight: 300,
      zIndex: 222,
      color: 'var(--text-color)',
    },
  },
  podcastInfoWrapper: {
    display: 'flex',
    gap: '16px',
    alignItems: 'flex-start',
    [theme.breakpoints.down('sm')]: {
      gap: '15px',
    },
  },
  podcastDetails: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    gap: 25,
    [theme.breakpoints.down('sm')]: {
      flexDirection: 'column',
      gap: 10,
    },
  },
  podcastDetailsWrapper: {
    display: 'block',
    textAlign: 'left',
  },
  podcastInfoText: {},
  podcastImage: {},
  podcastTitle: {},
  podcastEpisodes: {},
  podcastCategories: {},
  podcastCategoriesWrapper: {},
  podcastName: {},
}));
